const AcademyVue = () => {
    if (document.getElementById('academy-vue') ) {

    const PRESS_URL = document.getElementById('academy_url').value;
    const basic_username = document.getElementById('basic_username')?.value;
    const basic_pwd = document.getElementById('basic_pwd')?.value;

    let endpoint_academy = `${PRESS_URL}/wp-json/api/v1/korian_academy`;

    const app = new Vue({
        el: '#academy-vue',
        data() {
            return {
                academy : [],
                page: 1,
			    perPage: 9,
				pages: [],
				totaleAcademy : '',
                loading: true,
            }
        },
        mounted(){
            this.getAcademy();
            let vm = this;

        },
        computed: {
            paginatedAcademy(){
                this.totaleAcademy = this.computedAcademy.length;
                return this.paginate(this.computedAcademy);
            },
            computedAcademy(){
                return this.academy;
            }
        },
        methods: {

            getAcademy() {
                if ( basic_username && basic_pwd ) {

                    let credentials = btoa(basic_username+":"+basic_pwd);
                    let auth = { "Authorization" : `Basic ${credentials}` };
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + auth);
                    fetch( endpoint_academy, { headers : headers } )
                    .then(res => res.json())
                    .then(data => {
                        this.academy = data;
                        this.loading = false;
                    });

                }else{
                    fetch( endpoint_academy )
                    .then(res => res.json())
                    .then(data => {
                        this.academy = data;
                        this.loading = false;
                    });
                }

            },
            paginate (posts) {
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);
                return  posts.slice(from, to);
            },
            setPagesAcademy() {
                let numberOfPages = Math.ceil(this.totaleAcademy / this.perPage);
                this.pages = []; /* svuoto e ri-riempio */
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },
        },
        watch: {
            totaleAcademy() {
                this.setPagesAcademy(); /* ogni volta che totaleMedici cambia esegi setPages */
            }
        },
    });

    }
}


export default AcademyVue;
